import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import 'react-datepicker/dist/react-datepicker.css';
import { OfferForFrontendItemFragmentFragment } from '../../../generated/types';
import { HTMLText } from '../../Common/HTMLText';

interface HotelOfferModalProps {
  data?: OfferForFrontendItemFragmentFragment;
  isOpen: boolean;
  onClose: () => void;
}

export default function HotelOfferModal({
  data,
  isOpen,
  onClose,
}: HotelOfferModalProps) {
  return (
    <Modal
      size="xl"
      closeOnOverlayClick={false}
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalOverlay zIndex={1100}>
        <ModalContent>
          <ModalHeader>
            {data.title} - {data.subtitle}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box fontSize="xl" fontWeight="bold">
              Preis: {data.price} €
            </Box>
            <HTMLText mt={8} text={data.body} />
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Schließen
            </Button>
          </ModalFooter>
        </ModalContent>
      </ModalOverlay>
    </Modal>
  );
}
